import { render, staticRenderFns } from "./public-footer.vue?vue&type=template&id=d307f65a&scoped=true&"
import script from "./public-footer.vue?vue&type=script&lang=js&"
export * from "./public-footer.vue?vue&type=script&lang=js&"
import style0 from "./public-footer.vue?vue&type=style&index=0&id=d307f65a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d307f65a",
  null
  
)

export default component.exports